/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {SetOrderLiveActivityTokenRequest} from '@cash-web/protos/squareup/cash/local/client/v1/cash_app_local_client_service.pb'
import {SetOrderLiveActivityTokenResponse} from '@cash-web/protos/squareup/cash/local/client/v1/cash_app_local_client_service.pb'


export const setOrderLiveActivityToken = (request: SetOrderLiveActivityTokenRequest, options?: CashRequestOptions) => post<SetOrderLiveActivityTokenRequest, SetOrderLiveActivityTokenResponse>("/2.0/cash/set-order-live-activity-token", request, {...options, rejectOnError: true })